// Global win celebration bus — any engine can fire a shareable win popup.
let lastAt = 0;
const seen = new Set();

export const celebrateWin = ({ engine, amount, currency = "USD", extra = "", key = null, contract = null, symbol = null, note = "" }) => {
  const amt = Number(amount) || 0;
  if (amt <= 0) return;
  if (key) {
    if (seen.has(key)) return;
    seen.add(key);
    if (seen.size > 500) seen.clear();
  }
  const now = Date.now();
  if (now - lastAt < 2500) return; // tiny gap so rapid bot wins replace smoothly
  lastAt = now;
  try {
    window.dispatchEvent(new CustomEvent("vts:win", { detail: { engine, amount: amt, currency, extra, contract, symbol, note } }));
  } catch { /* ssr/safety */ }
};
